var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCircleShipping(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 38a19 19 0 110-38 19 19 0 010 38zm.5-29l-8.85 3.64 3.65 1.5 8.33-3.85zm5.36 2.2l-8.7 3.7 3.34 1.38 8.85-3.64-3.5-1.43zM29 13.44l-9.02 3.71V30L29 26.34zm-19 0v12.9L19.02 30V17.14l-3.32-1.36v3.72l-1.9-.73V15L10 13.43z"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle--shipping-ad768fd2242a426cd3977d084194e9f7.svg";
export { SvgIconCircleShipping as Component };